import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { Container, Row, Pagination, Col, Button, Form } from 'react-bootstrap'
import axios from 'axios'
import CardMarcas from "../CardMarcas/CardMarcas"
import Tables from '../Tables/Tables'
import { ImagenesMarcas } from './ImagenesMarcas'
import { BsFillGrid1X2Fill } from 'react-icons/bs'
import { FaThList } from 'react-icons/fa'
import "./CardStyle.css"
import { authContext } from '../Context/AuthContext'
import { globalContext } from '../Context/GlobalContext'
import { SpinnerMarcas } from '../helpers/SpinnerMarcas'
import { useTranslation } from 'react-i18next'
import { MdDownload } from "react-icons/md";
import { generarExcel } from '../../utilities/helpers/generadorExcel'

const apiProductos = process.env.REACT_APP_API_PRODUCTOS

export const ApiMap = () => {

  const { id } = useParams();
  const [idFound, setIdFound] = useState();
  const { token } = useContext(authContext);
  const { colorTheme, handleDisplayGrid, handleDisplayList, grid } = useContext(globalContext);
  const [articulosXMarca, setArticulosXMarca] = useState([]);
  const [largoTotal, setLargoTotal] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [load, setLoad] = useState(false);
  const elementosPorPagina = 50;
  const cantidadDePaginas = Math.ceil(largoTotal / elementosPorPagina);
  const country = process.env.REACT_APP_COUNTRY
  const [t] = useTranslation("global")


  const [min, setMin] = useState({});
  const [max, setMax] = useState({});
  const [sentido, setSentido] = useState({});
  const [filter, setFilter] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showOnlyStock, setShowOnlyStock] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [descargado, setDescargado] = useState(false);
  
  // Estados para filtro de Sistema Operativo
  const [filtroSistemaOperativo, setFiltroSistemaOperativo] = useState('');
  const [sistemasOperativosDisponibles, setSistemasOperativosDisponibles] = useState([]);
  const [articulosOriginales, setArticulosOriginales] = useState([]);

  // Función para extraer sistema operativo del nombre del producto
  const extraerSistemaOperativo = (nombre) => {
    if (!nombre) return 'Sin especificar';
    
    const nombreUpper = nombre.toUpperCase();
    
    if (nombreUpper.includes('W11P')) return 'Windows 11 Pro';
    if (nombreUpper.includes('W11H')) return 'Windows 11 Home';
    if (nombreUpper.includes('FREE')) return 'Free DOS';
    
    return 'Sin especificar';
  };

  // Función para obtener sistemas operativos únicos
  const obtenerSistemasOperativos = (articulos) => {
    const sistemas = [...new Set(articulos.map(art => extraerSistemaOperativo(art.Nombre)))];
    return sistemas.filter(sistema => sistema !== 'Sin especificar').sort();
  };

  // Función para aplicar filtro de sistema operativo
  const aplicarFiltroSistemaOperativo = (articulos) => {
    if (!filtroSistemaOperativo || filtroSistemaOperativo === '') {
      return articulos;
    }
    
    return articulos.filter(articulo => 
      extraerSistemaOperativo(articulo.Nombre) === filtroSistemaOperativo
    );
  };



  const borrarCampos = () => {
    setMin({});
    setMax({});
    setSentido({});
    const idValue = document.getElementById('sentido');
    if (!idValue) return false
    idValue.selectedIndex = '';
  }

  const obtenerDatos = async () => {
    try {
      setLoad(false);
      // if ((country === "USA") || (country === "ARG" && token)) {
      if (token) {
        const stockFilter = showOnlyStock ? 1 : 0;

        const response = await axios.get(`${apiProductos}/info/marca/${id}?Stock=${stockFilter}&limit=${elementosPorPagina}&offset=${elementosPorPagina * (currentPage - 1)}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });

        console.log("USA response", response);
        const articulosRespuesta = response.data.articulos || [];
        setArticulosOriginales(articulosRespuesta);
        
        // Aplicar filtro de sistema operativo si está activo
        const articulosFiltrados = aplicarFiltroSistemaOperativo(articulosRespuesta);
        setArticulosXMarca(articulosFiltrados);
        setLargoTotal(response.data.length);

        // Extraer sistemas operativos si estamos en ARG y en marcas HPC o LEC
        if (country === "ARG" && (id === "HPC" || id === "LEC") && articulosRespuesta) {
          const sistemasDisponibles = obtenerSistemasOperativos(articulosRespuesta);
          setSistemasOperativosDisponibles(sistemasDisponibles);
        } else {
          setSistemasOperativosDisponibles([]);
          setFiltroSistemaOperativo('');
        }

      } else {
        const response = await axios.get(`${apiProductos}/info/marca/${id}?limit=${elementosPorPagina}&offset=${elementosPorPagina * (currentPage - 1)}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });

        console.log(response);
        const articulosRespuesta = response.data.articulos || [];
        setArticulosOriginales(articulosRespuesta);
        
        // Aplicar filtro de sistema operativo si está activo
        const articulosFiltrados = aplicarFiltroSistemaOperativo(articulosRespuesta);
        setArticulosXMarca(articulosFiltrados);
        setLargoTotal(response.data.length);

        // Extraer sistemas operativos si estamos en ARG y en marcas HPC o LEC
        if (country === "ARG" && (id === "HPC" || id === "LEC") && articulosRespuesta) {
          const sistemasDisponibles = obtenerSistemasOperativos(articulosRespuesta);
          setSistemasOperativosDisponibles(sistemasDisponibles);
        } else {
          setSistemasOperativosDisponibles([]);
          setFiltroSistemaOperativo('');
        }
      }

      setTimeout(() => {
        setLoad(true);
      }, 1000);

      setIdFound(id);

    } catch (error) {
      console.log(error);
      setLoad(true);
    }
  };

  const filtrarPrecios = async () => {
    if (!filter) setCurrentPage(1);
    setFilter(true);

    try {
      let response;
      const stockFilter = showOnlyStock ? 1 : 0;

      if ((country === "USA") || (country === "ARG" && token)) {
        // Filtro de precios y stock para USA
        response = await axios.get(`${apiProductos}/info/marca/${id}?minPrice=${min.minPrice}&maxPrice=${max.maxPrice}&sentido=${sentido.sentido}&Stock=${stockFilter}&limit=${elementosPorPagina}&offset=${elementosPorPagina * (currentPage - 1)}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
      } else {
        // Filtro de precios sin stock para el resto de sucursales por ahora
        response = await axios.get(`${apiProductos}/info/marca/${id}?minPrice=${min.minPrice}&maxPrice=${max.maxPrice}&sentido=${sentido.sentido}&limit=${elementosPorPagina}&offset=${elementosPorPagina * (currentPage - 1)}`, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
      }

      console.log(response);
      setArticulosXMarca(response.data.articulos);
      setLargoTotal(response.data.length);
      
      // Extraer sistemas operativos si estamos en ARG y en marcas HPC o LEC
      if (country === "ARG" && (id === "HPC" || id === "LEC") && response.data.articulos) {
        const sistemasDisponibles = obtenerSistemasOperativos(response.data.articulos);
        setSistemasOperativosDisponibles(sistemasDisponibles);
      } else {
        setSistemasOperativosDisponibles([]);
        setFiltroSistemaOperativo('');
      }
      
      setLoad(true);
      setIdFound(id);

    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {
    if (id !== idFound) {
      setCurrentPage(1)
    }
    if (filter && id === idFound) filtrarPrecios()
    else {
      setFilter(false)
      obtenerDatos();
      borrarCampos();
    }
  }, [id, currentPage, showOnlyStock]);

  // useEffect separado para el filtro de sistema operativo
  useEffect(() => {
    if (articulosOriginales.length > 0 && country === "ARG" && (id === "HPC" || id === "LEC")) {
      const articulosFiltrados = aplicarFiltroSistemaOperativo(articulosOriginales);
      setArticulosXMarca(articulosFiltrados);
      setCurrentPage(1); // Resetear a la primera página al filtrar
    }
  }, [filtroSistemaOperativo]);

  useEffect(() => {
    const isMobileOnLoad = window.innerWidth < 670;
    setIsMobile(isMobileOnLoad);
    const handleResize = () => {
      setIsMobile(window.innerWidth < 670);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const paginas = [];
  function renderPagination() {
    for (let i = 1; i <= cantidadDePaginas; i++) {
      paginas.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => {
          setCurrentPage(i);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}>
          {i}
        </Pagination.Item>
      );
    }
  }

  useEffect(() => {
    if (articulosXMarca && articulosXMarca.length > 0) {
      setDescargado(false);
    }
  }, [articulosXMarca]);

  return (
    <div className={`api-map-container bg-${colorTheme}`}>
      <ImagenesMarcas id={id} />
      <Container fluid className='py-5' style={{ width: "100%" }}>

        {!isMobile && (
          <div className="display-select-container">
            <Col className={`d-flex justify-content-end text-${colorTheme === 'dark' ? 'light' : 'dark'}`}>
              <div className="row">
                <div className="span6" style={{ width: "115px" }}>
                  <div className="mycontent-left text-center">
                    <h6 className="text-uppercase">{t("producto.ver-como")}</h6>
                    <div className="d-flex flex-col justify-content-around gap-1">
                      <div
                        className={`d-flex flex-row align-items-center svgGrilla ${!grid ? 'activeView' : ''}`}
                        onClick={handleDisplayList}>
                        <FaThList size={"1.5em"} />
                      </div>
                      <div
                        className={`d-flex flex-row align-items-center svgGrilla ${grid ? 'activeView' : ''}`}
                        onClick={handleDisplayGrid}
                      >
                        <BsFillGrid1X2Fill size={"1.5em"} />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        )}


        <div style={{ display: !isMobile && 'flex', justifyContent: 'space-between' }}>
          {/* OCULTA BARRA IZQUIERDA SIN LOGIN */}
          {((country === "ARG" || country === "USA" || country === "UY" || country === "PA" || country === "CL") && token) && (

            <>
              {(country === "USA" || (country === "ARG" && token)) && (
                                    <div className="display-select-container">
                                        <h2 className='texto-filtros-titulo'>Filtrar:</h2>
                                        <h3 className="mb-3 textos-filtros">Por stock</h3>
                                        <Form.Check
                                            type="checkbox"
                                            id="stockCheckbox"
                                            label="Solo productos con stock"
                                            checked={showOnlyStock}
                                            onChange={(e) => setShowOnlyStock(e.target.checked)}
                                            style={{
                                                fontWeight: 'bold',
                                                fontSize: '15px',
                                                color: 'black', // aquí va el color negro
                                                cursor: 'pointer',
                                                userSelect: 'none'
                                            }}
                                        />

                                        {/* Filtro de Sistema Operativo - Solo para ARG en marcas HPC y LEC */}
                                        {country === "ARG" && (id === "HPC" || id === "LEC") && sistemasOperativosDisponibles.length > 0 && (
                                            <>
                                                <hr style={{ width: '50%', margin: '0 auto', border: 'none', height: '2px', backgroundColor: '#000', marginTop: '1em', marginBottom: '1em' }} />
                                                <h3 className="mb-3 textos-filtros">Sistema Operativo</h3>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-start',
                                                    gap: '8px',
                                                }}>
                                                    {/* Opción "Todos" */}
                                                    <label style={{
                                                        display: 'flex',
                                                        fontSize: '15px',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        cursor: 'pointer',
                                                        fontWeight: filtroSistemaOperativo === '' ? 'bold' : 'normal',
                                                        color: 'black',
                                                        whiteSpace: 'nowrap',
                                                    }}>
                                                        <input
                                                            type="radio"
                                                            name="sistemaOperativo"
                                                            checked={filtroSistemaOperativo === ''}
                                                            onChange={() => setFiltroSistemaOperativo('')}
                                                        />
                                                        Todos
                                                    </label>

                                                    {/* Opciones de sistemas operativos */}
                                                    {sistemasOperativosDisponibles.map((sistema, index) => (
                                                        <label key={index} style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            fontSize: '15px',   
                                                            gap: '10px',
                                                            cursor: 'pointer',
                                                            fontWeight: filtroSistemaOperativo === sistema ? 'bold' : 'normal',
                                                            color: 'black',
                                                            whiteSpace: 'nowrap',
                                                        }}>
                                                            <input
                                                                type="radio"
                                                                name="sistemaOperativo"
                                                                checked={filtroSistemaOperativo === sistema}
                                                                onChange={() => setFiltroSistemaOperativo(sistema)}
                                                            />
                                                            {sistema}
                                                        </label>
                                                    ))}
                                                </div>
                                            </>
                                        )}

                                        <hr style={{ width: '50%', margin: '0 auto', border: 'none', height: '2px', backgroundColor: '#000', marginTop: '0.5em', marginBottom: '1em' }} />
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button
                                                variant="outline-success"
                                                className="btn-descargar-stock px-2 py-2 text-center"
                                                onClick={() => generarExcel(articulosXMarca, setDescargado)}
                                                style={{ 
                                                    display: "flex", 
                                                    flexDirection: "column", 
                                                    alignItems: "center", 
                                                    opacity: showOnlyStock ? 1 : 0.5,
                                                    cursor: showOnlyStock ? "pointer" : "not-allowed",
                                                }}
                                                disabled={!showOnlyStock}
                                            >
                                                {showOnlyStock ? "Descargar planilla con Stock" : "Descargar planilla completa"}
                                                {/* <MdDownload size={25} style={{ marginTop: "4px" }} /> */}
                                            </Button>
                                        </div>
                                    </div>
                                )}
            </>
          )}

          {/* Segunda sección */}
          <div style={{ flex: 4 }}>
            {!load ? (
              <SpinnerMarcas text={'Cargando marca'} />
            ) : (
             <Row className='mt-2' style={{ justifyContent: "center" }}>
                <Col xs={12} md={12} sm={6} xl={9} lg={12}>
                  {articulosXMarca.length <= 0 ? (
                    <h3>{t("producto.no-existe")}</h3>
                  ) : isMobile ? (
                    <div className="taleShadow2 bg-light card-container">
                      <CardMarcas articulosXMarca={articulosXMarca} style={{ display: "flex", justifyContent: "center" }} />
                      <Pagination>{paginas}</Pagination>
                      <div>
                        {t("producto.pagina")} {currentPage} {t("producto.de")} {cantidadDePaginas}
                      </div>
                      {renderPagination()}
                    </div>
                  ) : grid ? (
                    <div className="taleShadow2 bg-light card-container">
                      <CardMarcas articulosXMarca={articulosXMarca} style={{ display: "flex", justifyContent: "center" }} />
                      <Pagination>{paginas}</Pagination>
                      <div>
                        {t("producto.pagina")} {currentPage} {t("producto.de")} {cantidadDePaginas}
                      </div>
                      {renderPagination()}
                    </div>
                  ) : (
                    <div className="taleShadow2 bg-light">
                      <Tables articulosXMarca={articulosXMarca}  header={["", ""]} />
                      <Pagination>{paginas}</Pagination>
                      <div>
                        {t("producto.pagina")} {currentPage} {t("producto.de")} {cantidadDePaginas}
                      </div>
                      {renderPagination()}
                    </div>
                  )}
                </Col>
              </Row>
            )}
          </div>
        </div>

      </Container>
    </div>
  )
}
